import React from 'react'
import { FormikProps } from 'formik'
import Input, { IInput } from '../Input'
import FormError from '../FormError'

export interface IInputForm extends IInput {
  children?: React.ReactNode
  formik: FormikProps<any>
  className: string
  errorContainerClassName?: string
  name: string
}

const InputForm: React.FC<IInputForm> = ({
  children,
  formik,
  name,
  errorContainerClassName,
  ...props
}) => {
  const {handleChange, getFieldMeta } = formik;

  const {error, value} = getFieldMeta(name);

  return (
    <>
      <Input
        {...props}
        name={name}
        error={error}
        handleChange={handleChange}
        value={String(value)}
      >
        {children}
      </Input>
       {!!error && (
        <div className={errorContainerClassName}>
          <FormError text={error || ''} />
        </div>
       )}
    </>
  );
};

export default InputForm;
